import React, { Suspense, useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import { addRecentAsset } from '@/shared/lib/storage/recentAssets';
import { buildAssetDetailUrl } from '@/shared/lib/url';
import type { MyAssetItem } from '@/shared/types/assetList';
import { AssetListCard } from '@/shared/ui/AssetListCard';
import { SuspenseFallback } from '@/shared/ui/SuspenseFallback';

import { MyAssetsTab } from '@/widgets/home/MyAssetsTab';

export const MyAssetsCard: React.FC = () => {
  const navigate = useNavigate();

  const handleAssetClick = useCallback(
    (asset: MyAssetItem) => {
      try {
        addRecentAsset({
          id: asset.id,
          name: asset.name,
          type: asset.type,
          fqn: asset.fqn,
          viewedAt: dayjs().toISOString(),
          ...(asset.projectId && { projectId: asset.projectId }),
          ...(asset.experimentId && { experimentId: asset.experimentId }),
          ...(asset.experimentName && { experimentName: asset.experimentName }),
        });
      } catch (error) {
        console.error('Failed to add recent asset:', error);
      }
      const detailUrl = asset.fqn.startsWith('/experiments/')
        ? asset.fqn
        : buildAssetDetailUrl(asset.type, asset.fqn, undefined, asset.id, asset.projectId);
      navigate(detailUrl);
    },
    [navigate]
  );

  return (
    <AssetListCard title="최근 변경된 자산">
      <Suspense fallback={<SuspenseFallback />}>
        <MyAssetsTab onAssetClick={handleAssetClick} />
      </Suspense>
    </AssetListCard>
  );
};
